import { ContactDataDisplayModelFormGroup } from '../../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { Component, OnInit, Input} from '@angular/core';
import {Validators } from '@angular/forms';
import { GlobalEnumsAceInformationsquelle } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-informationsquelle';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
@Component({
  selector: 'applicant-form',
  templateUrl: './applicant-form.component.html',
  styleUrls: ['./applicant-form.component.scss']
})
export class ApplicantFormComponent implements OnInit {
  @Input('form') contactDataForm: ContactDataDisplayModelFormGroup;

  public get informationsquelleList(): EnumValue[] {
    let informationsquelle = GlobalEnumsAceInformationsquelle.getAsDataset();
    informationsquelle.forEach(x => x.Description = this.translateservice.instant("Enum.GlobalEnumsAceInformationsquelle." + x.Name));
    return informationsquelle;
  }

  constructor(protected translateservice: I18nService, protected stateService: StateService) { 
  }

  ngOnInit(): void {
    if (this.stateService.IsEndvalidationEnabled) {
      this.contactDataForm.Informationsquelle.addValidators(Validators.required);
      this.contactDataForm.markAllAsTouched();
    }
    this.contactDataForm.Antragsteller.AbweichendeAdresse.setValue(true);
  }
}
